<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card class="elevation-12">
          <v-toolbar dark color="light-blue">
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <div id="subheader">
            Change Username
            <v-container fluid>
              <v-card-text>
                <p style="font-size: 16px"><i>{{ $store.state.user }}</i></p>
                <v-text-field prepend-icon="person" name="password" label="New Username" type="text" v-model="newUsername"></v-text-field>
              </v-card-text>
              <v-btn class="info" dark v-on:click="changeUsername()">Submit</v-btn>
            </v-container>
          </div>
          <div id="subheader">
            Change Password
            <v-container fluid>
              <v-card-text>
                <v-text-field prepend-icon="lock_open" name="password" label="Current Password" type="password" v-model="currentPassword"></v-text-field>
                <v-text-field prepend-icon="lock" name="password" label="New Password" type="password" v-model="newPassword"></v-text-field>
                <v-text-field prepend-icon="lock" name="password" label="Confirm New Password" type="password" v-model="newPasswordConfirm"></v-text-field>
              </v-card-text>
              <v-btn class="info" dark v-on:click="changePassword()">Submit</v-btn>
            </v-container>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {EventBus} from '@/event-bus.js'
  export default {
    data () {
      return {
        newUsername: '',
        currentPassword: '',
        newPassword: '',
        newPasswordConfirm: '',
      }
    },
    methods: {
      changePassword: function () {
        if(this.currentPassword === '' || this.newPassword === '' || this.newPasswordConfirm === '') {
          EventBus.$emit('send-notification', {text: 'Missing required fields'});
          return;
        }
        if(this.newPassword !== this.newPasswordConfirm) {
          EventBus.$emit('send-notification', {text: 'New passwords do not match'});
          return;
        }
        if(!this.validatePassword(this.newPassword)) {
          EventBus.$emit('send-notification', {text: 'Password must be at least 8 characters long and have at least 1 digit'});
          return;
        }
        this.$http.put(this.$store.state.serverHttpUrl+'/userSettings', 
        {email: this.$store.state.email, password: this.currentPassword, newPassword: this.newPassword}).then(
          function (response) {
            EventBus.$emit('send-notification', {text: 'Password changed successfully', color: 'success'});
            this.currentPassword = this.newPassword = this.newPasswordConfirm = '';
          }, function (err) {
            EventBus.$emit('send-notification', {text: 'Error changing password ('+err+')'});
        });
      },
      changeUsername: function () {
        if(this.newUsername === '') {
          EventBus.$emit('send-notification', {text: 'Missing required fields'});
          return;
        }
        this.$http.put(this.$store.state.serverHttpUrl+'/userSettings', 
        {email: this.$store.state.email, username: this.newUsername}).then(
          function (response) {
            this.newUsername = '';
            this.$store.dispatch('setToken', response.body)
            this.$store.dispatch('setUser', response.body)
            EventBus.$emit('send-notification', {text: 'Username changed successfully', color: 'success'});
          }, function (err) {
            EventBus.$emit('send-notification', {text: 'Error changing username ('+err+')'});
        });
      },
      validatePassword(pw) {
        var regex = /^(?=.*\d)[a-zA-Z0-9]{8,}$/;
        return regex.test(pw);
      }
    }
  }
</script>

<style>
  #header {
    margin: 5px;
    font-size: 30px;
    line-height: 1.5;
  }

  #subheader {
    margin: 20px;
    font-size: 20px;
    line-height: 1.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Settings.vue